import React from 'react';

const Certifications = () => {
  return (
    <section className="section certifications">
      <h2>Certifications</h2>
      <ul className="certification-list">
        <li>
          <a href="https://drive.google.com/file/d/1uwTzipGnbwICqztavK5WPivkXRVrMo4c/view" target="_blank" rel="noopener noreferrer">
            Jira for Beginners – Udemy
          </a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/14FjwblfkoRxESUEOinTVq-BhsA3n9AdL/view" target="_blank" rel="noopener noreferrer">
            Fundamentals of Data Analytics – NASSCOM
          </a>
        </li>
        <li>
          <a href="https://www.udemy.com/certificate/UC-e8a8c2d3-4fd3-4331-abdb-9b06c812e465/" target="_blank" rel="noopener noreferrer">
            Python and Django Full Stack Web Developer Bootcamp – Udemy
          </a>
        </li>
        <li>
          <a href="https://trainings.internshala.com/certificate/preview/web-development/coc/dashbaord/" target="_blank" rel="noopener noreferrer">
            Web Development – Internshala
          </a>
        </li>
        <li>
          <a href="https://media.licdn.com/dms/image/v2/C5622AQHS6KQKgPoYYg/feedshare-shrink_800/feedshare-shrink_800/0/1641793933851?e=1750896000&v=beta&t=5Hx2iFgXSezmzpKWvcaz8FOxk3DX3utO-t3pZ9OXjS8" target="_blank" rel="noopener noreferrer">
            Introduction to Programming using Python – Pride Educare
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Certifications;
